import { ShipmentForm } from '@prisma/client';

type OrderableShipmentForm = Pick<ShipmentForm, 'id' | 'parent_shipment_form_id'>;

export const orderMawbFirst = <T extends OrderableShipmentForm>(shipmentForms?: T[] | null): T[] => {
  const mawb = shipmentForms?.find((form) => !form.parent_shipment_form_id);
  if (!mawb) return [];

  const hawbs = (shipmentForms ?? [])
    .filter((form) => form.parent_shipment_form_id === mawb.id)
    .toSorted((a, b) => a.id - b.id);

  return [mawb, ...hawbs];
};
